import React from 'react';
import { TextField } from '@material-ui/core';
import styled from 'styled-components';
import HealtheraTable from '../../../../../../components/Table/Table';
import { Pharmacy } from '../../../../../../types/pharmacy';
import AddIcon from '@material-ui/icons/Add';

interface SearchPharmaciesProps {
  searchInput: string;
  setSearchInput: (value: string) => void;
  pharmacies: Pharmacy[];
  handleAdd: (pharmacy: Pharmacy) => void;
  disabled: boolean;
  disabledMessage?: string;
}

const SearchPharmacies: React.FC<SearchPharmaciesProps> = ({
  searchInput,
  setSearchInput,
  pharmacies,
  handleAdd,
  disabled,
  disabledMessage
}) => {
  const prepareSearchData = (items: Pharmacy[]) => {
    return [
      {
        view: {
          name: 'Name',
        },
        headers: true
      },
      ...items.map(item => ({
        view: {
          name: item.pharmacy_name,
        },
        button: {
          title: 'Add',
          onClick: () => handleAdd(item),
          icon: <AddIcon />
        }
      }))
    ];
  };

  return (
    <Section>
      <SearchContainer>
        <SearchField
          fullWidth
          label="Search Pharmacies"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          disabled={disabled}
          helperText={disabled ? disabledMessage : undefined}
        />
      </SearchContainer>

      {!disabled && searchInput.length > 2 && (
        <HealtheraTable
          data={prepareSearchData(pharmacies)}
          displayPagination={false}
          page={0}
          rowsPerPage={pharmacies.length}
          rowsPerPageOptions={[]}
          onChangePage={() => {}}
          onRowsPerPageChange={() => {}}
          totalCount={pharmacies.length}
          isLiveDashboard={false}
          noHover={true}
        />
      )}
    </Section>
  );
};

const Section = styled.div`
  flex: 1;
  width: 50%;
  min-width: 0;
`;

const SearchContainer = styled.div`
  padding-bottom: 24px;
`;

const SearchField = styled(TextField)`
  width: 100%;
`;

export default SearchPharmacies; 
